// per device look switches, kept in this browser only

export interface Look {
  scanlines: boolean;
  calm: boolean;
  // ui sounds: off, soft, blip or click
  sfx: string;
  // what a tap leaves behind: off, ripple or spark
  tap: string;
  // particle bursts, cursor glow and press pulses, and short vibrations on key actions
  juice: boolean;
  haptics: boolean;
  // tiles lean toward the pointer and main buttons pull toward it
  tilt: boolean;
}

export const SFX_CHOICES = ["off", "soft", "blip", "click"];
export const TAP_CHOICES = ["off", "ripple", "spark"];

const KEY = "chix-look";

export function readLook(): Look {
  try {
    const saved = JSON.parse(localStorage.getItem(KEY) || "{}") as Partial<Look>;
    return {
      scanlines: saved.scanlines ?? true,
      calm: saved.calm ?? false,
      sfx: SFX_CHOICES.includes(saved.sfx ?? "") ? saved.sfx! : "off",
      tap: TAP_CHOICES.includes(saved.tap ?? "") ? saved.tap! : "off",
      juice: saved.juice ?? true,
      haptics: saved.haptics ?? true,
      tilt: saved.tilt ?? true
    };
  } catch {
    return { scanlines: true, calm: false, sfx: "off", tap: "off", juice: true, haptics: true, tilt: true };
  }
}

export function paintLook(look = readLook()): void {
  document.documentElement.classList.toggle("scanlines", look.scanlines);
  document.documentElement.classList.toggle("calm", look.calm);
  document.documentElement.classList.toggle("nojuice", !look.juice);
  document.documentElement.classList.toggle("notilt", !look.tilt);
}

export function writeLook(changes: Partial<Look>): void {
  const next = { ...readLook(), ...changes };
  try {
    localStorage.setItem(KEY, JSON.stringify(next));
  } catch {
    // private mode, still paint it for this visit
  }
  paintLook(next);
}
